<script setup lang="ts">
import axios from 'axios';
import { shallowRef } from 'vue';

const props = defineProps<{
	enabled: boolean;
	remoteAccessUrl: string;
}>();

const loading = shallowRef(false);
const error = shallowRef<string | null>(null);

async function connect() {
	if (!props.enabled || loading.value) return;

	try {
		loading.value = true;
		error.value = null;

		const response = await axios.get<{ url: string }>(props.remoteAccessUrl);

        loading.value = false;
        
		window.open(response.data.url, '_blank', 'noopener');
	} catch (exception) {
		if (axios.isAxiosError(exception)) {
			error.value = exception.response?.data?.message ?? 'Não foi possível obter a URL de acesso remoto.';
			return;
		}

		error.value = 'Não foi possível obter a URL de acesso remoto.';
	}
}
</script>

<template>
	<div class="card">
		<div class="card-body">
			<h4>Acesso remoto</h4>

			<button
				type="button"
				class="btn btn-primary"
				:disabled="!props.enabled || loading"
				@click="connect">
				<span v-if="loading">
					<i class="fa fa-spinner fa-spin"></i>
					Carregando...
				</span>
				<span v-else>Conectar</span>
			</button>

			<p
				v-if="!props.enabled"
				class="mb-0 mt-3">
				Acesso remoto não habilitado neste computador.
			</p>

			<div
				v-if="error"
				class="alert alert-danger fw-bold mt-3 mb-0">
				{{ error }}
			</div>
		</div>
	</div>
</template>
